module.exports = __webpack_public_path__ + "1b77b86f11f6abe527eb6d5f215f37c4.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/en/stingray_karaoke.png
// module id = 859
// module chunks = 0